import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { removeActionTypes }    from 'Utils/ReducerUtility';
import { IAppUserState }        from 'Redux/Slices/AppUser/AppUserSlice';

export const assignAppUserEventsRequest = (state: Draft<IAppUserState>, { type }: PayloadAction<{ userId: string, organisationId: string, eventIds: string[] }>) => {
  state.openRequests = [ ...state.openRequests, type ];
  state.failedRequests = removeActionTypes(state.failedRequests, type);
  state.updatedAt = Date.now();
};

export const assignAppUserEventsSuccess = (state: Draft<IAppUserState>, { type, payload }: PayloadAction<{ organisationId: string, eventIds: string[] }>) => {
  state.updatedAt = Date.now();
  state.openRequests = removeActionTypes(state.openRequests, type);
  state.assignedEventIdsByOrganisation[payload.organisationId] = payload.eventIds;
};

export const assignAppUserEventsFailure = (state: Draft<IAppUserState>, { type }: PayloadAction<{ error: any }>) => {
  state.updatedAt = Date.now();
  state.failedRequests = [ ...state.failedRequests, type ];
  state.openRequests = removeActionTypes(state.openRequests, type);
};
